import { ChangeDetectionStrategy, Component, input, TemplateRef, inject } from '@angular/core';
import { commentType } from '@trade-platform/lib-enums';
import { OrderFormComment } from '@trade-platform/ui-shared';
import { isInProgress } from 'ngx-remotedata';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrderFormCommentsMode } from '../order-form-comments/order-form-comments';
import { BaseOrdersStoreFacade, ORDERS_STORE_FACADE } from '../../base.orders.store.facade';
import { OrderFormCommentsPipe } from '../order-form-comments-pipe';
import { NgClass, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { AixDataTestingDirective, AixLoadingComponent } from '@trade-platform/ui-components';

@Component({
    selector: 'aix-order-form-comments-list',
    templateUrl: 'order-form-comments-list.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        AixLoadingComponent,
        AixDataTestingDirective,
        NgClass,
        NgTemplateOutlet,
        AsyncPipe,
        OrderFormCommentsPipe
    ]
})
export class AixOrderFormCommentsListComponent {
    store = inject<BaseOrdersStoreFacade>(ORDERS_STORE_FACADE);

    commentRef = input<TemplateRef<any>>();
    comments = input<OrderFormComment[]>();
    showSystemUpdates = input<boolean>(true);
    mode = input<OrderFormCommentsMode>();

    isLoading$: Observable<boolean>;

    commentType = commentType;

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const store = this.store;

        this.isLoading$ = combineLatest([
            store.orderFormCommentCreateRemoteData$,
            store.orderFormCommentUpdateRemoteData$,
            store.orderFormCommentDeleteRemoteData$,
            store.orderFormCommentsRemoteData$
        ]).pipe(map(states => states.some(isInProgress)));
    }
}
